import { useMemo } from "react";

const useGroupedDataWithTotals = (arrGroupedDataTable) => {
  const result = useMemo(() => {
    const groupedDataWithTotals = arrGroupedDataTable.reduce((acc, curr) => {
      const {
        regionName,
        "Higher Secondary": HigherSecondary = 0,
        Secondary = 0,
        Primary = 0,
        "Upper Primary": UpperPrimary = 0,

        Overall = 0,
        total = 0,
        "categoriesHigher Secondary only/Jr College":
          categoriesHigherSecondaryonlyJrCollege = 0,
        "categoriesPr Up Pr and Secondary Only":
          categoriesPrUpPrandSecondaryOnly = 0,
        "categoriesPr with UpPr Sec and HSec":
          categoriesPrwithUpPrSecandHSec = 0,
        categoriesPrimary: categoriesPrimary = 0,
        "categoriesPrimary with Upper Primary":
          categoriesPrimarywithUpperPrimary = 0,
        "categoriesSecondary Only": categoriesSecondaryOnly = 0,
        "categoriesSecondary with Higher Secondary":
          categoriesSecondarywithHigherSecondary = 0,
        "categoriesUp Pr Secondary and Higher Sec":
          categoriesUpPrSecondaryandHigherSec = 0,

        "categoriesUpper Pr and Secondary": categoriesUpperPrandSecondary = 0,
        "categoriesUpper Primary only": categoriesUpperPrimaryonly = 0,
        totTchFSocCatCd1 = 0,
        totTchMSocCatCd1 = 0,
        totTchFSocCatCd4 = 0,
        totTchMSocCatCd4 = 0,
        totTchFSocCatCd2 = 0,
        totTchMSocCatCd2 = 0,
        totTchFSocCatCd3 = 0,
        totTchMSocCatCd3 = 0,

        maleTeachersDisability2 = 0,
        femaleTeachersDisability2 = 0,
        teachersDisability2 = 0,
        maleTeachersDisability3 = 0,
        femaleTeachersDisability3 = 0,
        teachersDisability3 = 0,
        maleTeachersDisability5 = 0,
        femaleTeachersDisability5 = 0,
        teachersDisability5 = 0,
        maleTeachersDisability4 = 0,
        femaleTeachersDisability4 = 0,
        teachersDisability4 = 0,

        totTchRegM = 0,
        totTchRegF = 0,
        totTchReg = 0,
        totTchNonRegM = 0,
        totTchNonRegF = 0,
        totTchNonReg = 0,

        totTchCWSNTrained=0,
        totTchCWSNTrainedF= 0,
        totTchCWSNTrainedM= 0,

        totSchElectricity = 0,

        totSch = 0,
        class1B = 0,
        class1G = 0,
        class2B = 0,
        class2G = 0,
        class3B = 0,
        class3G = 0,
        class4B = 0,
        class4G = 0,
        class5B = 0,
        class5G = 0,
        class6B = 0,
        class6G = 0,
        class7B = 0,
        class7G = 0,
        class8B = 0,
        class8G = 0,
        class9B = 0,
        class9G = 0,
        class10B = 0,
        class10G = 0,
        class11B = 0,
        class11G = 0,
        class12B = 0,
        class12G = 0,
        prePry2B = 0,
        prePry2G = 0,
        prePry1B = 0,
        prePry1G = 0,
        prePry3B = 0,
        prePry3G = 0,
        totEnrPrePryB = 0,
        totEnrPryG = 0,
        totEnrSecB = 0,
        totEnrSecG = 0,
        totEnrUPryB = 0,
        totEnrUPryG = 0,
        totEnrPryB = 0,
        totEnrPrePryG = 0,
        totSchFuncCompAvail = 0,
        totSchCompleteMedicalCheckup = 0,
        totSchFuncDrinkingWater = 0,
        totSchFuncUrinal = 0,
        totSchUrinal = 0,
        totSchGirlsUrinal = 0,
        totSchGirls = 0,
        totSchToilet = 0,
        totSchBoysUrinal = 0,
        totSchFuncToilet = 0,
        totSchGirlsCoedToilet = 0,
        totSchBoys = 0,
        totSchBoysCoedToilet = 0,
        totSchFuncElectricity = 0,
        totSchSeprateRoomHm = 0,
        totSchLandAvail = 0,
        totSchSolarPanel = 0,
        totSchFuncSolarPanel = 0,
        totSchPlayground = 0,
        totSchLibrary = 0,
        totSchLibrarian = 0,
        totSchNewspaper = 0,
        totSchKitchenGarden = 0,
        totSchFurniture = 0,
        totSchBoysToilet = 0,
        totSchFuncBoysToilet = 0,
        totSchGirlsToilet = 0,
        totSchFuncGirlsToilet = 0,
        schHaveToilet = 0,
        totSchFuncBoysUrinal = 0,
        schHaveFuncUrinals = 0,
        totSchFuncGirlsUrinal = 0,
        totSchDrinkingWater = 0,
        totSchFuncWaterPurifier = 0,
        totSchWaterPurifier = 0,
        totSchRainWaterHarvesting = 0,
        totSchWaterTested = 0,
        totSchIncinerator = 0,
        totSchHandwashMeals = 0,
        totSchRamps = 0,
        totSchHandRails = 0,
        totSchMedicalCheckup = 0,
        schHaveCompleteMedicalCheckup = 0,
        totSchInternet = 0,
        totSchCompAvail = 0,
        totSchHandwashToilet = 0,
        c1B =0,
        c1G =0,
        c2B =0,
        c2G =0,
        c3B =0,
        c3G =0,
        c4B =0,
        c4G =0,
        c5B =0,
        c5G =0,
        c6B =0,
        c6G =0,
        c7B =0,
        c7G =0,
        c8B =0,
        c8G =0,
        c9B =0,
        c9G =0,
        c10B =0,
        c10G =0,
        c11B =0,
        c11G =0,
        c12B =0,
        c12G =0,
        pp1B =0,
        pp1G =0,
        pp2B =0,
        pp2G =0,
        pp3B =0,
        pp3G =0,
      } = curr;

      if (!acc[regionName]) {
        acc[regionName] = {
          records: [],

          totals: {
            regionName: ` ${regionName}`,
            "School Management(Broad)": "Overall",
            "School Management(Detailed)": "Overall",
            schManagementBroad: "Overall",
            schManagementDesc: "Overall",
            schCategoryBroad: "Overall",
            schCategoryDesc: "Overall ",
            schLocationDesc: "Overall ",
            schTypeDesc: "Overall",
            Primary: 0,
            "Upper Primary": 0,
            "Higher Secondary": 0,
            Secondary: 0,
            Overall: 0,
            total: 0,

            "categoriesHigher Secondary only/Jr College": 0,
            "categoriesPr Up Pr and Secondary Only": 0,
            "categoriesPr with UpPr Sec and HSec": 0,
            categoriesPrimary: 0,
            "categoriesPrimary with Upper Primary": 0,
            "categoriesSecondary Only": 0,
            "categoriesSecondary with Higher Secondary": 0,
            "categoriesUp Pr Secondary and Higher Sec": 0,
            "categoriesUpper Pr and Secondary": 0,
            "categoriesUpper Primary only": 0,
            totTchFSocCatCd1: 0,
            totTchMSocCatCd1: 0,
            totTchFSocCatCd4: 0,
            totTchMSocCatCd4: 0,
            totTchFSocCatCd2: 0,
            totTchMSocCatCd2: 0,
            totTchFSocCatCd3: 0,
            totTchMSocCatCd3: 0,

            maleTeachersDisability2: 0,
            femaleTeachersDisability2: 0,
            teachersDisability2: 0,
            maleTeachersDisability3: 0,
            femaleTeachersDisability3: 0,
            teachersDisability3: 0,
            maleTeachersDisability5: 0,
            femaleTeachersDisability5: 0,
            teachersDisability5: 0,
            maleTeachersDisability4: 0,
            femaleTeachersDisability4: 0,
            teachersDisability4: 0,

            totTchRegM: 0,
            totTchRegF: 0,
            totTchReg: 0,
            totTchNonRegM: 0,
            totTchNonRegF: 0,
            totTchNonReg: 0,

            totTchCWSNTrained:0,
            totTchCWSNTrainedF: 0,
            totTchCWSNTrainedM: 0,
    


            totSchElectricity: 0,

            totSch: 0,
            class1G: 0,
            class1B: 0,
            class2G: 0,
            class2B: 0,
            class3G: 0,
            class3B: 0,
            class4G: 0,
            class4B: 0,
            class5G: 0,
            class5B: 0,
            class6G: 0,
            class6B: 0,
            class7G: 0,
            class7B: 0,
            class8G: 0,
            class8B: 0,
            class9G: 0,
            class9B: 0,
            class10G: 0,
            class10B: 0,
            class11G: 0,
            class11B: 0,
            class12G: 0,
            class12B: 0,
            prePry2B: 0,
            prePry2G: 0,
            prePry1B: 0,
            prePry1G: 0,
            prePry3B: 0,
            prePry3G: 0,
            totEnrPryG: 0,
            totEnrSecB: 0,
            totEnrSecG: 0,
            totEnrUPryB: 0,
            totEnrUPryG: 0,
            totEnrPryB: 0,
            totEnrPrePryG: 0,
            totEnrPrePryB: 0,
            totSchFuncCompAvail: 0,
            totSchCompleteMedicalCheckup: 0,
            totSchFuncDrinkingWater: 0,
            totSchFuncUrinal: 0,
            totSchUrinal: 0,
            totSchGirlsUrinal: 0,
            totSchGirls: 0,
            totSchBoysUrinal: 0,
            totSchFuncToilet: 0,
            totSchToilet: 0,
            totSchGirlsCoedToilet: 0,
            totSchBoys : 0,
            totSchBoysCoedToilet : 0,
            totSchFuncElectricity: 0,
            totSchSeprateRoomHm: 0,
            totSchLandAvail: 0,
            totSchSolarPanel: 0,
            totSchFuncSolarPanel: 0,
            totSchPlayground: 0,
            totSchLibrary: 0,
            totSchLibrarian: 0,
            totSchNewspaper: 0,
            totSchKitchenGarden: 0,
            totSchFurniture: 0,
            totSchBoysToilet: 0,
            totSchFuncBoysToilet: 0,
            totSchGirlsToilet: 0,
            totSchFuncGirlsToilet: 0,
            schHaveToilet: 0,
            totSchFuncBoysUrinal: 0,
            schHaveFuncUrinals: 0,
            totSchFuncGirlsUrinal: 0,
            totSchDrinkingWater: 0,
            totSchFuncWaterPurifier: 0,
            totSchWaterPurifier: 0,
            totSchRainWaterHarvesting: 0,
            totSchWaterTested: 0,
            totSchIncinerator: 0,
            totSchHandwashMeals: 0,
            totSchRamps: 0,
            totSchHandRails: 0,
            totSchMedicalCheckup: 0,
            schHaveCompleteMedicalCheckup: 0,
            totSchInternet: 0,
            totSchCompAvail: 0,

            totSchHandwashToilet: 0,
            isTotalRow: true,
            c1B:0,
            c1G:0,
            c2B:0,
            c2G:0,
            c3B:0,
            c3G:0,
            c4B:0,
            c4G:0,
            c5B:0,
            c5G :0,
            c6B :0,
            c6G :0,
            c7B :0,
            c7G :0,
            c8B:0,
            c8G :0,
            c9B :0,
            c9G :0,
            c10B :0,
            c10G :0,
            c11B :0,
            c11G :0,
            c12B :0,
            c12G :0,     
        pp1B:0, 
        pp1G:0, 
        pp2B:0, 
        pp2G:0, 
        pp3B:0, 
        pp3G:0, 
          },
        };
      }

      acc[regionName].records.push(curr);

      acc[regionName].totals.Primary += Primary;
      acc[regionName].totals["Upper Primary"] += UpperPrimary;

      acc[regionName].totals["Higher Secondary"] += HigherSecondary;
      acc[regionName].totals.Secondary += Secondary;
      acc[regionName].totals.Overall += Overall;
      acc[regionName].totals.total += total;

      acc[regionName].totals["categoriesHigher Secondary only/Jr College"] +=
        categoriesHigherSecondaryonlyJrCollege;
      acc[regionName].totals["categoriesPr Up Pr and Secondary Only"] +=
        categoriesPrUpPrandSecondaryOnly;
      acc[regionName].totals["categoriesPr with UpPr Sec and HSec"] +=
        categoriesPrwithUpPrSecandHSec;
      acc[regionName].totals["categoriesPrimary"] += categoriesPrimary;
      acc[regionName].totals["categoriesPrimary with Upper Primary"] +=
        categoriesPrimarywithUpperPrimary;
      acc[regionName].totals["categoriesSecondary Only"] +=
        categoriesSecondaryOnly;

      acc[regionName].totals["categoriesSecondary with Higher Secondary"] +=
        categoriesSecondarywithHigherSecondary;
      acc[regionName].totals["categoriesUp Pr Secondary and Higher Sec"] +=
        categoriesUpPrSecondaryandHigherSec;
      acc[regionName].totals["categoriesUpper Pr and Secondary"] +=
        categoriesUpperPrandSecondary;
      acc[regionName].totals["categoriesUpper Primary only"] +=
        categoriesUpperPrimaryonly;

      acc[regionName].totals.totTchFSocCatCd1 += totTchFSocCatCd1;
      acc[regionName].totals.totTchMSocCatCd1 += totTchMSocCatCd1;
      acc[regionName].totals.totTchFSocCatCd4 += totTchFSocCatCd4;
      acc[regionName].totals.totTchMSocCatCd4 += totTchMSocCatCd4;
      acc[regionName].totals.totTchFSocCatCd2 += totTchFSocCatCd2;
      acc[regionName].totals.totTchMSocCatCd2 += totTchMSocCatCd2;

      acc[regionName].totals.totTchFSocCatCd3 += totTchFSocCatCd3;
      acc[regionName].totals.totTchMSocCatCd3 += totTchMSocCatCd3;

      acc[regionName].totals.maleTeachersDisability2 += maleTeachersDisability2;
      acc[regionName].totals.femaleTeachersDisability2 += femaleTeachersDisability2;
      acc[regionName].totals.teachersDisability2 += teachersDisability2;
      acc[regionName].totals.maleTeachersDisability3 += maleTeachersDisability3;
      acc[regionName].totals.femaleTeachersDisability3 += femaleTeachersDisability3;
      acc[regionName].totals.teachersDisability3 += teachersDisability3;
      acc[regionName].totals.maleTeachersDisability5 += maleTeachersDisability5;
      acc[regionName].totals.femaleTeachersDisability5 += femaleTeachersDisability5;
      acc[regionName].totals.teachersDisability5 += teachersDisability5;
      acc[regionName].totals.maleTeachersDisability4 += maleTeachersDisability4;
      acc[regionName].totals.femaleTeachersDisability4 += femaleTeachersDisability4;
      acc[regionName].totals.teachersDisability4 += teachersDisability4;

      acc[regionName].totals.totTchRegM += totTchRegM;
      acc[regionName].totals.totTchRegF += totTchRegF;
      acc[regionName].totals.totTchReg += totTchReg;
      acc[regionName].totals.totTchNonRegM += totTchNonRegM;
      acc[regionName].totals.totTchNonRegF += totTchNonRegF;
      acc[regionName].totals.totTchNonReg += totTchNonReg;

      acc[regionName].totals.totTchCWSNTrainedM += totTchCWSNTrainedM;
      acc[regionName].totals.totTchCWSNTrainedF += totTchCWSNTrainedF;
      acc[regionName].totals.totTchCWSNTrained += totTchCWSNTrained;




      acc[regionName].totals.totSchElectricity += totSchElectricity;
      acc[regionName].totals.totSch += totSch;
      acc[regionName].totals.class1G += class1G;
      acc[regionName].totals.class1B += class1B;
      acc[regionName].totals.class2G += class2G;
      acc[regionName].totals.class2B += class2B;
      acc[regionName].totals.class3G += class3G;
      acc[regionName].totals.class3B += class3B;
      acc[regionName].totals.class4B += class4B;
      acc[regionName].totals.class4G += class4G;
      acc[regionName].totals.class5B += class5B;
      acc[regionName].totals.class5G += class5G;
      acc[regionName].totals.class6B += class6B;
      acc[regionName].totals.class6G += class6G;
      acc[regionName].totals.class7B += class7B;
      acc[regionName].totals.class7G += class7G;
      acc[regionName].totals.class8B += class8B;
      acc[regionName].totals.class8G += class8G;
      acc[regionName].totals.class9B += class9B;
      acc[regionName].totals.class9G += class9G;
      acc[regionName].totals.class10B += class10B;
      acc[regionName].totals.class10G += class10G;
      acc[regionName].totals.class11B += class11B;
      acc[regionName].totals.class11G += class11G;
      acc[regionName].totals.class12B += class12B;
      acc[regionName].totals.class12G += class12G;
      acc[regionName].totals.prePry2B += prePry2B;
      acc[regionName].totals.prePry2G += prePry2G;
      acc[regionName].totals.prePry1B += prePry1B;
      acc[regionName].totals.prePry1G += prePry1G;
      acc[regionName].totals.prePry3B += prePry3B;
      acc[regionName].totals.prePry3G += prePry3G;
      acc[regionName].totals.totEnrPryG += totEnrPryG;
      acc[regionName].totals.totEnrSecB += totEnrSecB;
      acc[regionName].totals.totEnrSecB += totEnrSecB;
      acc[regionName].totals.totEnrSecG += totEnrSecG;
      acc[regionName].totals.totEnrUPryB += totEnrUPryB;
      acc[regionName].totals.totEnrUPryG += totEnrUPryG;
      acc[regionName].totals.totEnrPryB += totEnrPryB;
      acc[regionName].totals.totEnrPrePryB += totEnrPrePryB;
      acc[regionName].totals.totEnrPrePryG += totEnrPrePryG;
      acc[regionName].totals.totSchFuncCompAvail += totSchFuncCompAvail;
      acc[regionName].totals.totSchCompleteMedicalCheckup += totSchCompleteMedicalCheckup;
      acc[regionName].totals.totSchFuncDrinkingWater += totSchFuncDrinkingWater;
      acc[regionName].totals.totSchFuncUrinal += totSchFuncUrinal;
      acc[regionName].totals.totSchUrinal += totSchUrinal;
      acc[regionName].totals.totSchGirlsUrinal += totSchGirlsUrinal;
      acc[regionName].totals.totSchGirls += totSchGirls;
      acc[regionName].totals.totSchBoysUrinal += totSchBoysUrinal;
      acc[regionName].totals.totSchFuncToilet += totSchFuncToilet;
      acc[regionName].totals.totSchToilet += totSchToilet;
      acc[regionName].totals.totSchGirlsCoedToilet += totSchGirlsCoedToilet;
      acc[regionName].totals.totSchBoys += totSchBoys;
      acc[regionName].totals.totSchBoysCoedToilet += totSchBoysCoedToilet;
      acc[regionName].totals.totSchFuncElectricity += totSchFuncElectricity;
      acc[regionName].totals.totSchSeprateRoomHm += totSchSeprateRoomHm;
      acc[regionName].totals.totSchLandAvail += totSchLandAvail;
      acc[regionName].totals.totSchSolarPanel += totSchSolarPanel;
      acc[regionName].totals.totSchFuncSolarPanel += totSchFuncSolarPanel;
      acc[regionName].totals.totSchPlayground += totSchPlayground;
      acc[regionName].totals.totSchLibrary += totSchLibrary;
      acc[regionName].totals.totSchLibrarian += totSchLibrarian;
      acc[regionName].totals.totSchNewspaper += totSchNewspaper;
      acc[regionName].totals.totSchKitchenGarden += totSchKitchenGarden;
      acc[regionName].totals.totSchFurniture += totSchFurniture;
      acc[regionName].totals.totSchBoysToilet += totSchBoysToilet;
      acc[regionName].totals.totSchFuncBoysToilet += totSchFuncBoysToilet;
      acc[regionName].totals.totSchGirlsToilet += totSchGirlsToilet;
      acc[regionName].totals.totSchFuncGirlsToilet += totSchFuncGirlsToilet;
      acc[regionName].totals.schHaveToilet += schHaveToilet;
      acc[regionName].totals.totSchFuncBoysUrinal += totSchFuncBoysUrinal;
      acc[regionName].totals.schHaveFuncUrinals += schHaveFuncUrinals;
      acc[regionName].totals.totSchFuncGirlsUrinal += totSchFuncGirlsUrinal;
      acc[regionName].totals.totSchDrinkingWater += totSchDrinkingWater;
      acc[regionName].totals.totSchFuncWaterPurifier += totSchFuncWaterPurifier;
      acc[regionName].totals.totSchWaterPurifier += totSchWaterPurifier;
      acc[regionName].totals.totSchRainWaterHarvesting +=
        totSchRainWaterHarvesting;
      acc[regionName].totals.totSchWaterTested += totSchWaterTested;
      acc[regionName].totals.totSchIncinerator += totSchIncinerator;
      acc[regionName].totals.totSchHandwashMeals += totSchHandwashMeals;
      acc[regionName].totals.totSchRamps += totSchRamps;
      acc[regionName].totals.totSchHandRails += totSchHandRails;
      acc[regionName].totals.totSchMedicalCheckup += totSchMedicalCheckup;
      acc[regionName].totals.schHaveCompleteMedicalCheckup +=
        schHaveCompleteMedicalCheckup;
      acc[regionName].totals.totSchInternet += totSchInternet;
      acc[regionName].totals.totSchCompAvail += totSchCompAvail;
      acc[regionName].totals.totSchHandwashToilet += totSchHandwashToilet;
      acc[regionName].totals.c1B += c1B;
      acc[regionName].totals.c1G += c1G;
      acc[regionName].totals.c2B += c2B;
      acc[regionName].totals.c2G += c2G;
      acc[regionName].totals.c3B += c3B;
      acc[regionName].totals.c3G += c3G;
      acc[regionName].totals.c4B += c4B;
      acc[regionName].totals.c4G += c4G;
      acc[regionName].totals.c5B += c5B;
      acc[regionName].totals.c5G += c5G;
      acc[regionName].totals.c6B += c6B;
      acc[regionName].totals.c6G += c6G;
      acc[regionName].totals.c7B += c7B;
      acc[regionName].totals.c7G += c7G;
      acc[regionName].totals.c8B += c8B;
      acc[regionName].totals.c8G += c8G;
      acc[regionName].totals.c9B += c9B;
      acc[regionName].totals.c9G += c9G;
      acc[regionName].totals.c10B += c10B;
      acc[regionName].totals.c10G += c10G;
      acc[regionName].totals.c11B += c11B;
      acc[regionName].totals.c11G += c11G;
      acc[regionName].totals.c12B += c12B;
      acc[regionName].totals.c12G += c12G;

      acc[regionName].totals.pp1B += pp1B;
      acc[regionName].totals.pp1G += pp1G;
      acc[regionName].totals.pp2B += pp2B;
      acc[regionName].totals.pp2G += pp2G;
      acc[regionName].totals.pp3B += pp3B;
      acc[regionName].totals.pp3G += pp3G;

      return acc;
    }, {});

    const finalResult = Object.values(groupedDataWithTotals).reduce(
      (finalArr, { records, totals }) => {
        return [...finalArr, ...records, totals];
      },
      []
    );
    return finalResult;
  }, [arrGroupedDataTable]);

  return result;
};

export default useGroupedDataWithTotals;
